<div [ngStyle]="{ 'display' : addProjectController.active? 'block' : 'none'}"
  [ngClass]="tabsService.minimizeScreenMode ? 'bottom-menu minimized' : ''">
  <form autocomplete="off" data-tab="1" id="coordindatePointsForm" [ngClass]="active ? 'active' : ''">
    <div class="fields__block">
      <div class="fields__block__section">
        <div class="title">
          <h4>NavAids List</h4>
          <span> </span>
        </div>
        <div class="table-fields">
          <div>
            <label
              [ngClass]="[colapsableLabelNavAidsList ? 'active' : '', colapsableLabelNavAidsList ? 'colapsable' : 'colapsable']"
              for="" (click)="colapsableLabelNavAidsListTrigger()">NavAids List</label>
            <div
              [ngClass]="[colapsableDivNavAidsList ? 'active' : '', colapsableDivNavAidsList ? 'colapsable' : 'colapsable']">
              <table>
                <thead>
                  <tr>
                    <th scope="col">ID</th>
                    <th scope="col">Type</th>
                  </tr>
                </thead>
                <tbody>
                  <tr *ngFor="let navaid of this.configController?.currentConfiguration?.navaids; let i = index"
                    (click)="selectNavaidRow(navaid)" [class.highlighted]="navaid.isselected">
                    <td>{{navaid.navaidid}}</td>
                    <td>{{navaid.navaidtype}}</td>
                  </tr>
                </tbody>
              </table>
              <div class="btn">
                <a class="selectMap" title="Select on Map" (click)="selectNavaidFeatures()"></a>
                <a class="unselectMap" title="UnSelect on Map" (click)="unSelectNavaidFeatures()"></a>
                <a class="clearMap" title="Clear Map" (click)="clearSelectedNavaids()"></a>
                <a class="selectTable" title="Select all list" (click)="selectAllNavaids()"></a>
                <a class="addToTable" title="Add to list" (click)="addSelectedNavaids()"></a>
                <a class="removeFromTable" title="Remove from list" (click)="removeSelectedNavaids()"></a>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="fields__block__section">
        <div class="title">
          <h4>Coordinate Points List</h4>
          <span> </span>
        </div>
        <div class="table-fields">
          <div>
            <label
              [ngClass]="[colapsableLabelCoPointsList ? 'active' : '', colapsableLabelCoPointsList ? 'colapsable' : 'colapsable']"
              for="" (click)="colapsableLabelCoPointsListTrigger()">Coordinate Points List</label>
            <div
              [ngClass]="[colapsableDivCoPointsList ? 'active' : '', colapsableDivCoPointsList ? 'colapsable' : 'colapsable']">
              <table>
                <thead>
                  <tr>
                    <th scope="col">ID</th>
                    <th scope="col">Type</th>
                  </tr>
                </thead>
                <tbody>
                  <tr
                    *ngFor="let coord_point of this.configController?.currentConfiguration?.coordPoints; let i = index"
                    (click)="selectCoordPointRow(coord_point)" [class.highlighted]="coord_point.isselected">
                    <td>{{coord_point.coordpointid}}</td>
                    <td>{{coord_point.type}}</td>
                  </tr>
                </tbody>
              </table>
              <div class="btn">
                <a class="selectMap" title="Select on Map" (click)="selectCoordPointFeatures()"></a>
                <a class="unselectMap" title="UnSelect on Map" (click)="unSelectCoordPointFeatures()"></a>
                <a class="clearMap" title="Clear Map" (click)="clearSelectedCoordPoints()"></a>
                <a class="selectTable" title="Select all list" (click)="selectAllCoordPoints()"></a>
                <a class="addToTable" title="Add to list" (click)="addSelectedCoordPoints()"></a>
                <a class="removeFromTable" title="Remove from list" (click)="removeSelectedCoordPoints()"></a>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="fields__block">
      <div class="fields__block__section">
        <div class="title">
          <h4>Procedures List</h4>
          <span> </span>
        </div>
        <div class="table-fields">
          <div>
            <label
              [ngClass]="[colapsableLabelProceduresList ? 'active' : '', colapsableLabelProceduresList ? 'colapsable' : 'colapsable']"
              for="" (click)="colapsableLabelProceduresListTrigger()">Procedures List</label>
            <div
              [ngClass]="[colapsableDivProceduresList ? 'active' : '', colapsableDivProceduresList ? 'colapsable' : 'colapsable']">
              <table>
                <thead>
                  <tr>
                    <th scope="col">ID</th>
                    <th scope="col">Type</th>
                  </tr>
                </thead>
                <tbody>
                  <tr *ngFor="let proc of this.configController?.currentConfiguration?.procedures; let i = index"
                    (click)="selectProcedureRow(proc)" [class.highlighted]="proc.isselected">
                    <td>{{proc.name}}</td>
                    <td>{{proc.proceduretype}}</td>
                  </tr>
                </tbody>
              </table>
              <div class="btn">
                <a class="selectMap" title="Select on Map" (click)="selectProcedureFeatures()"></a>
                <a class="unselectMap" title="UnSelect on Map" (click)="unSelectProcedureFeatures()"></a>
                <a class="clearMap" title="Clear Map" (click)="clearSelectedProcedures()"></a>
                <a class="selectTable" title="Select all list" (click)="selectAllProcedures()"></a>
                <a class="addToTable" title="Add to list" (click)="addSelectedProcedures()"></a>
                <a class="removeFromTable" title="Remove from list" (click)="removeSelectedProcedures()"></a>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="fields__block__section">
        <div class="title">
          <h4>Air Space Boundaries List</h4>
          <span> </span>
        </div>
        <div class="table-fields">
          <div>
            <label
              [ngClass]="[colapsableLabelBoundariesList ? 'active' : '', colapsableLabelBoundariesList ? 'colapsable' : 'colapsable']"
              for="" (click)="colapsableLabelBoundariesListTrigger()">Air Space Boundaries List</label>
            <div
              [ngClass]="[colapsableDivBoundariesList ? 'active' : '', colapsableDivBoundariesList ? 'colapsable' : 'colapsable']">
              <table>
                <thead>
                  <tr>
                    <th scope="col">ID</th>
                    <th scope="col">Type</th>
                  </tr>
                </thead>
                <tbody>
                  <tr
                    *ngFor="let airspace of this.configController?.currentConfiguration?.airspaceBoundaries; let i = index"
                    (click)="selectAirspaceBoundaryRow(airspace)" [class.highlighted]="airspace.isselected">
                    <td>{{airspace.name}}</td>
                    <td>Air Space Boundary</td>
                  </tr>
                </tbody>
              </table>
              <div class="btn">
                <a class="selectMap" title="Select on Map" (click)="selectAirspaceFeatures();"></a>
                <a class="unselectMap" title="UnSelect on Map" (click)="unSelectAirspaceFeatures();"></a>
                <a class="clearMap" title="Clear Map" (click)="clearSelectedAirspaceBondaries();"></a>
                <a class="selectTable" title="Select all list" (click)="selectAllAirspaceBoundaries();"></a>
                <a class="addToTable" title="Add to list" (click)="addSelectedAirspaceBoundaries();"></a>
                <a class="removeFromTable" title="Remove from list" (click)="removeSelecteAirspaceBoundaries();"></a>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="fields__btn">
      <button type="submit" class="blue" (click)="saveSettings()">
        Save
      </button>
      <a class="gray" href="#" type="reset" value="Cancel" (click)="cancelProjectEdition()">Cancel</a>
    </div>
  </form>
</div>
